import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

// Kontrola Datovka (Identifikator datove schranky)
//
// 0 - OK
// 1 - E: nezadano
// 2 - E: chybna syntaxe
// 3 - E: chybna kontrolka

// inicializace – oficialni Base32 abeceda ISDS
const BASE32_ALPHABET = 'abcdefghijkmnpqrstuvwxyz23456789';

// Mapovanie znaku -> hodnota
const base32Alphabet: Record<string, number> = {};
for (let i = 0; i < BASE32_ALPHABET.length; i++) {
    base32Alphabet[BASE32_ALPHABET[i]] = i;
}

function verifyLuhn32(str: string): boolean {
    const BASE = 32;
    let sum = 0;
    const length = str.length;

    for (let i = 0; i < length; i++) {
        // get digits in reverse order
        const char = str[length - i - 1];
        let digit = base32Alphabet[char];

        // safety check (should never happen if regex passed)
        if (digit === undefined) {
            return false;
        }

        digit *= (i % 2) + 1; // every 2nd number multiply with 2
        sum += digit > BASE - 1 ? digit - (BASE - 1) : digit;
    }

    return sum % BASE === 0;
}

export function checkDatovka(str?: string | null): number {
    if (!str || str.length === 0) {
        return 1; // nezadano
    }

    if (!/^[a-km-np-z2-9]{7}$/.test(str)) {
        return 2; // chybna syntaxe
    }

    if (!verifyLuhn32(str)) {
        return 3; // chybna kontrolka
    }

    return 0; // OK
}

export const datovaSchrankaValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || (value && checkDatovka(value) === 0)) return Promise.resolve();
            return Promise.reject(<TranslateText>DATOVA_SCHRANKA_ERR</TranslateText>);
        }
    })
];

export default datovaSchrankaValidation;
